// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"3d1e0998","527":"640bfa7a"}[chunkId] + ".chunk.js";
};